import i18n from '@/lang'

export default {
  path: '/payment-package/index',
  name: 'payment',
  redirect: '/subscription-plans',
  component: () => import('@pt/views/payment-package/index'),
  hidden: true,
  meta: {
    payment: 'free',
    title: i18n.t('playTurbo.payment.router.title'),
    defaultPath: '/payment-package/index',
  },
}
